import React from 'react'
import {StaticQuery, graphql} from 'gatsby'
import PropTypes from 'prop-types'
import TopBarElement from './components/TopBar'

const TopBar = ({dark}) => <StaticQuery
	query={graphql`{
				topBar: file(relativePath: {eq: "global/topbar.json"}) {
					childGlobalJson {
						logoLink
						logoAlt
						items {
							label
							link
						}
						button {
							label
							link
						}
						loginButton {
							label
							link
						}
					}
				}
			}`}
	render={({topBar: {childGlobalJson: data}}) => <TopBarElement dark={dark} {...data}/>}/>


TopBar.propTypes = {
	dark: PropTypes.bool,
}

TopBar.defaultProps = {
	dark: false,
}

export default TopBar
